import axios from 'src/utils/request'
export const androidSdk = {
    list: (...args: any[]) => 
        axios.post('/sdkAndroid/getSdkList', ...args),

    add: (...args: any[]) => 
        axios.post('/sdkAndroid/addSdk', ...args),

    update: (...args: any[]) => 
        axios.post('/sdkAndroid/updateSdk', ...args),

    delete: (...args: any[]) => 
        axios.post('/sdkAndroid/deleteSdk', ...args),

    getSdkConfig: (...args: any[]) => 
        axios.post('/sdkAndroid/getSdkConfig', ...args),

    bindSdkToAdNetwork: (...args: any[]) => 
        axios.post('/sdkAndroid/bindSdkToAdNetwork', ...args),

}

export const iosSdk = {
    list: (...args: any[]) => 
        axios.post('/sdkIos/getSdkList', ...args),

    add: (...args: any[]) => 
        axios.post('/sdkIos/addSdk', ...args),

    update: (...args: any[]) => 
        axios.post('/sdkIos/updateSdk', ...args),

    delete: (...args: any[]) => 
        axios.post('/sdkIos/deleteSdk', ...args),

    getSdkConfig: (...args: any[]) => 
        axios.post('/sdkIos/getSdkConfig', ...args),

    bindSdkToAdNetwork: (...args: any[]) => 
        axios.post('/sdkIos/bindSdkToAdNetwork', ...args),
}